export class CalloutEntity {
  constructor({
    name,
    component,
    props,
    sitemapId, // define blacklist that should not display the callout
    priority,
    timeout = -1,
  }) {
    this.name = name;
    this.component = component;
    this.props = props;
    this.sitemapId = sitemapId;
    this.priority = priority;
    this.timeout = timeout;
  }
}
